import styled from 'styled-components';

export const STitle = styled.div`
    font-size: 1.4rem;
    font-weight: bold;
    margin-bottom: 1rem;
`;
